import React from 'react'
import {connect} from "react-redux";
import { Route } from 'react-router-dom'
import Icon from 'components/common/elements/Icon'
import { statuses } from "store/auth/consts";

import Preloader from 'components/common/elements/Preloader'
import { userStatuses } from 'store/auth'
import history from 'services/browserHistory'
import { path as addCardPath } from "components/routes/authGroup/AddCard";
import { inviteCodePath } from "components/routes/authGroup/InviteCode";

import style from './UnauthLayout.scss'


const allowedRoutes = [
  addCardPath,
]


const UnauthLayout = ({ component: Component, userStatus, accStatus, ...rest }) => {
  // if (userStatus == userStatuses.LOADING) return <Preloader/>;
  if (accStatus == statuses.PENDING && location.pathname != addCardPath) {
     history.push(addCardPath);
     return <Preloader/>;
  }
  if (userStatus == userStatuses.AUTH && accStatus != statuses.PENDING && allowedRoutes.indexOf(location.pathname) == -1) {
    console.log('userStatus', 'accStatus', userStatus, accStatus)
    history.push('/');
    return <Preloader/>;
  }

  return (
    <Route {...rest} render={ matchProps => (
      <div className={`${style.UnauthLayout} ${style.blue}`}>
        <div className={style.UnauthLayoutContentOverlay}>
          <div className={style.UnauthLayoutContent}>
            <Icon icon="logo" width='230' height="76" className={style.UnauthLayoutLogoIcon}/>
            {/*<div className={style.UnauthLayoutLogo}>*/}
            {/*  Who Visited Me*/}
            {/*</div>*/}

            <Component {...matchProps} />
          </div>
        </div>
      </div>
    )}/>
  )
}

// export default UnauthLayout

const mapStateToProps = (state) => ({
  userStatus: state.auth.status,
  accStatus: (state.entities.users[state.auth.id] || {}).status,
})

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(UnauthLayout)
